export default {
  facebook: require('./facebook.png'),
  google: require('./google.png')
};



// WEBPACK FOOTER //
// ./src/components/pages/User/Social/SocialLoginButton/img/index.js